var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"not-found__group"},[(_vm.notFound)?_c('img',{staticClass:"img",attrs:{"src":_vm.notFound,"alt":"Not Found"}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }